module.exports = __webpack_public_path__ + "static/media/smallClientIcon.021aaeff.svg";